import md5 from 'blueimp-md5'

function createSysSignStr(param, key) {
  console.log(param)
  let tmp =[
    ['App_Sub_ID', param.App_Sub_ID],
    ['App_Token', param.App_Token],
    ['User_Token', param.User_Token],
    ['Api_ID', param.Api_ID],
    ['Api_Version', param.Api_Version],
    ['Time_Stamp', param.Time_Stamp],
    ['Partner_ID', param.Partner_ID],
    [
      "REQUEST_DATA",
      typeof param.REQUEST_DATA == "string"
        ? param.REQUEST_DATA
        : JSON.stringify(param.REQUEST_DATA)
    ],
    ['App_ID', param.App_ID],
    ['App_Version', param.App_Version],
    ['Divice_ID', param.Divice_ID],
    ['Divice_Version', param.Divice_Version],
    ['OS_Version', param.OS_Version]
  ]
  tmp.sort()
  return (
    tmp.map(item => {
        return item.join('=')
      })
      .join('&') +'&'+ key
  )
}

export default (param, key) => {
  let tempStr = createSysSignStr(param, key)
  console.log('签名前' + tempStr)
  return md5(tempStr).toUpperCase()
}
